import React from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'

const CustomSelect = ({ id, label, width, dataList, selectedId, onChange, disabled, inputRef }) => {
  
  // 初期値がdatatListに存在するか確認
  const isValidValue = dataList.some(item => item.id == selectedId);

  return (
    <FormControl className="formcontrol" variant="outlined" size="small"  sx={{ width: width || 'auto', backgroundColor:'#fff' }}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        id       = {id}
        label    = {label}
        onChange = {onChange}
        value    = {isValidValue ? selectedId : ''}
        disabled = {disabled}
        style    = {{textAlign:'left'}}
        inputRef = { inputRef } 
      >
        {dataList.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default CustomSelect